import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Input, Checkbox, Typography, Button, List, Space, Empty, Cascader, Tag, Radio, Spin, Dropdown } from 'antd';

import { createUseStyles } from 'react-jss'

import { POST, errorCatch, GET, JSXMap, Model, useAuth } from 'fennec-ui'
import Icofont from 'react-icofont';
import { Action } from 'fennec-ui'
import Collection from '../../../common/Collection';

import InputWithSearchModal from '../../components/InputWithSearchModal'
import UserFilter from '../UserFilter'
import UserSelector from '../UserSelector'
import uuid from 'react-uuid';
import { Agreement } from '../../../common/Agreement';
import { DownOutlined } from '@ant-design/icons';
import Nl2Br from '../../../common/Nl2br';

import parse from "html-react-parser";
import dayjs from 'dayjs'
import locale from 'antd/es/date-picker/locale/ru_RU';
import 'dayjs/locale/ru'

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

var _ = require('lodash');

const useStyles = createUseStyles({
    selectPeople: {
        paddingBottom: "5px",
        '& .ant-input-prefix': {
            marginRight: "11px"
        },
        '& .ant-input-affix-wrapper': {
            padding: "4px 0px"
        }
    },
    listMeta: {
        '& .ant-list-item-meta-title': {
            marginBottom: "0"
        },
    },
    itemsListUsluga: {
        '& .ant-list .ant-list-item': {
            // borderBottom: "1px solid #e1e1e1",
            alignItems: "flex-start"
        },
    },
    itemsOrderUsluga: {
        '& .ant-list-item': {
            alignItems: "flex-start"
        },
    },
    promo: {
        '& .ant-input-affix-wrapper': {
            paddingLeft: "0px",
        },
        '&': {
            borderBottom: "1px solid darkblue",
        },
        '&:hover': {
            borderBottom: "2px solid darkblue",
        },
    },
    appendButton: {
        '&.ant-btn': {
            // width: "100%",
            backgroundColor: "#d9d9d9",
            boxShadow: "0px 1px 3px 0px rgba(141,141,141,0.74)",
            fontWeight: 600
        },
        '&.ant-btn:hover': {
            color: "#000",
            // background: #fff;
            boxShadow: "0px 2px 4px 0px rgba(141,141,141,0.74)",
            borderColor: "#d9d9d9",
        },
        '&.ant-btn:focus': {
            color: "#000",
            // background: #fff;
            boxShadow: "0px 2px 4px 0px rgba(141,141,141,0.74)",
            borderColor: "#d9d9d9",
        }
    }
})

const Header = ({ icon, title, style }) => {
    return (<span>
        <Icofont icon={icon} style={style} />
        <span>{title}</span>
    </span>);
};
const SingleHeader = () => {
    return (<Header icon="user-alt-3" title="Одиночный" style={{ color: "cadetblue", fontSize: "13px", paddingRight: "6px" }} />);
};
const CoupleHeader = () => {
    return (<Header icon="users-alt-4" title="Парный" style={{ color: "purple", fontSize: "13px", paddingRight: "6px" }} />);
};
const FemaleHeader = () => {
    return (<Header icon="businesswoman" title="Женский" style={{ color: "red", fontSize: "16px", paddingRight: "6px" }} />);
};
const MaleHeader = () => {
    return (<Header icon="businessman" title="Мужской" style={{ color: "blue", fontSize: "16px", paddingRight: "6px" }} />);
};
const SelectCategory = (props) => {
    const { item, value, onChange } = props;
    const [selection, setSelection] = useState();
    // const actionFunc = React.useMemo(() => (values, unlock, close, properties) => {
    //     let o = { ...values, polzovatelID: (values.polzovatel) ? values.polzovatel.ID : undefined }
    //     onChange(o);
    //     close();
    // }, [onChange])
    const optionsFunc = (item) => {
        let dance = {};
        if (item) {
            item?.uslugiKlientuKategoriiUslugaKlienta?.forEach(e => {
                if (e.dostupnaRegistratsiya) {
                    dance[e.kategoriya.tantsevalnayaDistsiplinaID] = {
                        value: e.kategoriya.tantsevalnayaDistsiplinaID,
                        label: e.kategoriya.tantsevalnayaDistsiplina.nazvanie,
                        children: _.unionBy(
                            (dance[e.kategoriya.tantsevalnayaDistsiplinaID] && dance[e.kategoriya.tantsevalnayaDistsiplinaID].children) ? dance[e.kategoriya.tantsevalnayaDistsiplinaID].children : [],
                            [{
                                kategoriyaID: e.kategoriya.ID,
                                object: e,
                                ID: e.kategoriya.kategoriyaUchastnikovID,
                                value: e.kategoriya.kategoriyaUchastnikovID,
                                label: e.kategoriya.kategoriyaUchastnikov.nazvanie,
                            }],
                            'ID'),
                    }
                }
            });
        }
        return Object.values(dance);
    };
    useEffect(() => {
        if (value) {
            let a = optionsFunc(item);
            let o = [];
            for (let i = 0; i < a.length; i++) {
                const first = a[i];
                for (let j = 0; j < first.children.length; j++) {
                    const second = first.children[j];
                    if (second && value && value.kategoriya && second.kategoriyaID === value.kategoriya.kategoriyaID) {
                        o.push(first);
                        o.push(second);
                    }
                }
            }
            setSelection((o.length == 2) ? o : undefined);
        }
    }, [item, value])
    return (<span>
        <span> - </span>
        <span style={{ fontStyle: "italic" }}>
            <Cascader options={optionsFunc(item)} onChange={(value, selectedOptions) => {
                if (onChange) {
                    onChange(selectedOptions[1].object);
                }
                setSelection(selectedOptions);
            }}>
                <a onClick={(e) => e.preventDefault()}>{(selection) ? selection.map(o => o.label).join(' / ') : <span style={{ color: "red" }}>Укажите категорию!</span>}</a>
            </Cascader>
        </span>
    </span>);
};
const SelectPeople = (props) => {
    const classes = useStyles();
    const user = useSelector(state => state.home.user);
    const { auth, item, data, gender, prefix, value, onChange, onChangeSilent } = props;

    const display = (object) => {
        if (object === undefined) {
            return <span>Укажите участника!</span>;
        }
        if (object) {
            if (object.polzovatelStrokoi) {
                return <span>{object.polzovatelStrokoi}</span>;
            }
            if (object.polzovatel) {
                return <span>{object.polzovatel.firstname + " " + object.polzovatel.lastname}</span>;
            }
            return <span>Укажите участника!</span>;
        }
        return <></>;
    };
    const triggerFunc = React.useMemo(() => (click) => (<Tag color={(value === undefined) ? "red" : ""} onClick={click}>
        {display(value)}
    </Tag>), [value]);
    const actionFunc = React.useMemo(() => (values, unlock, close) => {
        // otherPolzovatel

        // console.log(values);

        let o = {
            // ...values, 
            polzovatelStrokoi: values.polzovatelStrokoi,
            polzovatel: (values.otherPolzovatel) ? values.otherPolzovatel : values.polzovatel,
            polzovatelID: (values.otherPolzovatel) ? values.otherPolzovatel.ID : (values.polzovatel) ? values.polzovatel.ID : undefined,
        }
        onChange(o);
        close();
    }, [onChange])
    const setCategoryFunc = React.useMemo(() => (okazannieUslugiPolzovatelyamUchastikItem) => {
        POST(auth, "/api/zakaz/tovar/okazannieuslugipolzovatelyam/setkategory", okazannieUslugiPolzovatelyamUchastikItem,
            ({ data }) => {
                let o = {
                    ...value, okazannieUslugiPolzovatelyamUchastik: value.okazannieUslugiPolzovatelyamUchastik.map(e => {
                        if (e.ID === data.ID) {
                            return data;
                        }
                        return e;
                    })
                }
                onChangeSilent(o);
            }, errorCatch);
    }, [onChange])
    const setPartnerFunc = React.useMemo(() => (okazannieUslugiPolzovatelyamUchastikItem) => {
        POST(auth, "/api/zakaz/tovar/okazannieuslugipolzovatelyam/setpartner", okazannieUslugiPolzovatelyamUchastikItem,
            ({ data }) => {
                let o = {
                    ...value, okazannieUslugiPolzovatelyamUchastik: value.okazannieUslugiPolzovatelyamUchastik.map(e => {
                        if (e.ID === data.ID) {
                            return data;
                        }
                        return e;
                    })
                }
                // onChange(o)
                onChangeSilent(o);
            }, errorCatch);
    }, [onChange])
    const styleFunc = React.useMemo(() => ({ paddingLeft: "10px", cursor: "pointer" }));
    const modalFunc = React.useMemo(() => ({ title: "Указать участника", width: "500px" }));
    const filteredValue = (value && value.okazannieUslugiPolzovatelyamUchastik) ? value.okazannieUslugiPolzovatelyamUchastik.filter(i => i.uslugaKlientu.yacheikaUsluga.prilozhenieID) : undefined;
    return (<div className={classes.selectPeople}>
        <div>
            {prefix}
            <span style={styleFunc}>
                <Action
                    auth={auth}
                    mode="func"
                    modal={modalFunc}
                    object={value}
                    okText="Выбрать"
                    gender={gender}
                    user={user}
                    item={item}
                    data={data}
                    form={SelectUserForm}
                    action={actionFunc}
                    trigger={triggerFunc}
                />
            </span>
        </div>
        {!!value && <Services
            data={data}
            value={filteredValue}
            onChangeCategory={(value, okazannieUslugiPolzovatelyamUchastikItem) => {
                let o = { ...okazannieUslugiPolzovatelyamUchastikItem, kategoriyaID: value.ID };
                setCategoryFunc(o)
            }}
            onChangePartner={(value, okazannieUslugiPolzovatelyamUchastikItem) => {
                let o = { ...okazannieUslugiPolzovatelyamUchastikItem, partnerID: value.ID };
                setPartnerFunc(o)
            }} />}
    </div>);
};
const SelectPartner = (props) => {
    const auth = useAuth()
    const { item, value, onChange, data } = props;
    const user = useSelector(state => state.home.user);
    const modalFunc = React.useMemo(() => ({ title: "Указать " + ((value?.tipTDID === 1) ? "ассистента" : "партнера"), width: "500px" }));

    const display = (object) => {
        if (!object) {
            return <span>Укажите {(value?.tipTDID === 1) ? "ассистента" : "партнера"}!</span>;
        }
        if (object) {
            return <span>{object.firstname + " " + object.lastname}</span>;
        }
        return <></>;
    };
    const triggerFunc = React.useMemo(() => (click) => (<div style={{ cursor: "pointer", fontStyle: "italic", color: (!value?.partner) ? "red" : "grey" }} onClick={click}>
        {display(value?.partner)}
    </div>), [value?.partner]);

    const actionFunc = React.useMemo(() => (values, unlock, close) => {
        onChange(
            (values.otherPolzovatel) ? values.otherPolzovatel : values.polzovatel
        );
        close();
    }, [onChange])

    // const finduserAction = React.useCallback((values, unlock, close) => {
    //     POST(auth, "/api/find/finduserfilter", { ...values },
    //         ({ data }) => {
    //             close(data);
    //         },
    //         (err) => errorCatch(err, unlock));
    // }, [auth])

    // const steps = React.useMemo(() => [
    //     {
    //         key: "search",
    //         name: "Шаг 1",
    //         action: finduserAction,
    //         form: Model,
    //         meta: [
    //             {
    //                 label: "Email",
    //                 name: "Email",
    //                 type: "string",
    //                 display: (v) => v,
    //                 validators: {
    //                     required: true,
    //                     min: null,
    //                     max: null,
    //                     pattern: null
    //                 },
    //             },
    //             {
    //                 label: "Фамилия",
    //                 name: "Lastname",
    //                 type: "string",
    //                 display: (v) => v,
    //                 validators: {
    //                     required: true,
    //                     min: null,
    //                     max: null,
    //                     pattern: null
    //                 },
    //             },
    //             {
    //                 label: "Имя",
    //                 name: "Firstname",
    //                 type: "string",
    //                 display: (v) => v,
    //                 validators: {
    //                     required: true,
    //                     min: null,
    //                     max: null,
    //                     pattern: null
    //                 },
    //             },
    //         ],
    //     },
    //     {
    //         key: "select",
    //         name: "Шаг 2",
    //         noAntForm: true,
    //         form: (props) => {
    //             return (
    //                 <div style={{ padding: "0px 10px" }}>
    //                     <div>Подтвердите выбор пользователя:</div>
    //                     <div>ФИО: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.firstname + " " + props.data.search.lastname : ""}</span></div>
    //                     <div>Email: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.email : ""}</span></div>
    //                 </div>
    //             )
    //         },
    //     }
    // ], [auth, finduserAction])

    return (<div style={{ display: "flex", gap: "5px" }}>
        <div style={{ fontStyle: "italic" }}> - {(value?.tipTDID === 1) ? "ассистент" : "партнер"} - </div>
        <div>
            <Action
                auth={auth}
                mode="func"
                trigger={triggerFunc}
                action={actionFunc}
                // steps={steps}
                title={"Выбор " + ((value?.tipTDID === 1) ? "ассистента" : "партнера")}
                modal={{
                    minWidth: "250px",
                    title: "Выбрать " + ((value?.tipTDID === 1) ? "ассистента" : "партнера"),
                }}

                object={value}
                okText="Выбрать"
                user={user}
                item={item}
                data={data}
                form={SelectPartnerForm}
            />
        </div>
    </div>);
};
const Services = (props) => {
    const { auth, data, value, onChangeCategory, onChangePartner } = props;
    const onCategoryChange = (value, okazannieUslugiPolzovatelyamUchastikItem) => {
        onChangeCategory(value, okazannieUslugiPolzovatelyamUchastikItem);
    };
    const onPartnerChange = (value, okazannieUslugiPolzovatelyamUchastikItem) => {
        onChangePartner(value, okazannieUslugiPolzovatelyamUchastikItem);
    };
    const find = (data, i) => {
        let o = (data) ? data.find(e => e.ID === i.uslugaKlientuID) : undefined;;
        return o;
    };
    return (<div style={{ paddingTop: "3px", fontSize: "13px" }}>
        {(!!value) && value.map((i, idx) => {

            return (<div key={idx}>
                <div style={{ display: "flex", gap: "5px" }}>
                    <div>- {i.uslugaKlientu.yacheikaUsluga.nazvanie}</div>
                    <div>
                        <SelectCategory
                            auth={auth}
                            item={find(data, i)}
                            value={i}
                            onChange={(v) => onCategoryChange(v, i)}
                        />
                        {(i?.tipTDID === 1 || i?.tipTDID === 2) && <div>
                            <SelectPartner
                                auth={auth}
                                item={find(data, i)}
                                value={i}
                                data={data}
                                onChange={(v) => onPartnerChange(v, i)}
                            />
                        </div>}
                    </div>
                </div>
            </div>)
        }
        )}
    </div>);
};
const Male = (props) => {
    const { auth, item, index, value, onChange, onChangeSilent, usluga } = props;
    const data = (usluga && usluga.uslugiKlientuUslugaNaMeropriyatii) ? usluga.uslugiKlientuUslugaNaMeropriyatii : undefined;// usluga.uslugiKlientuUslugaNaMeropriyatii.filter(i => i.yacheikaUsluga.prilozhenieID) : undefined;
    const gender = 1;
    const setMergedObject = (obj) => {
        onChange({
            genderID: gender,
            polzovatelStrokoi: obj.polzovatelStrokoi,
            polzovatelID: _.get(obj, "polzovatel.ID"),
            tovarVZakazeID: item.ID
        });
    };
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            gender={gender}
            prefix={<MaleHeader />}
            item={item}
            index={index}
            data={data}
            value={value}
            onChangeSilent={onChangeSilent}
            onChange={(e) => setMergedObject(e)} />
    </div>);
};
const Female = (props) => {
    const { auth, item, index, value, onChange, onChangeSilent, usluga } = props;
    const data = (usluga && usluga.uslugiKlientuUslugaNaMeropriyatii) ? usluga.uslugiKlientuUslugaNaMeropriyatii : undefined;// usluga.uslugiKlientuUslugaNaMeropriyatii.filter(i => i.yacheikaUsluga.prilozhenieID) : undefined;
    const gender = 2;
    const setMergedObject = (obj) => {
        onChange({
            genderID: gender,
            polzovatelStrokoi: obj.polzovatelStrokoi,
            polzovatelID: _.get(obj, "polzovatel.ID"),
            tovarVZakazeID: item.ID
        });
    };

    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            gender={gender}
            item={item}
            index={index}
            data={data}
            prefix={<FemaleHeader />}
            value={value}
            onChangeSilent={onChangeSilent}
            onChange={(e) => setMergedObject(e)} />
    </div>);
};
const Single = (props) => {
    const { auth, item, index, value, onChange, onChangeSilent, usluga } = props;
    const data = (usluga && usluga.uslugiKlientuUslugaNaMeropriyatii) ? usluga.uslugiKlientuUslugaNaMeropriyatii : undefined;// usluga.uslugiKlientuUslugaNaMeropriyatii.filter(i => i.yacheikaUsluga.prilozhenieID) : undefined;
    const setMergedObject = (obj) => {
        onChange({
            polzovatelStrokoi: obj.polzovatelStrokoi,
            polzovatelID: _.get(obj, "polzovatel.ID"),
            tovarVZakazeID: item.ID
        });
    };
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            prefix={<SingleHeader />}
            item={item}
            index={index}
            data={data}
            value={value}
            onChangeSilent={onChangeSilent}
            onChange={(e) => setMergedObject(e)} />
    </div>);
};
const SingleByGender = (props) => {
    const { auth, item, index, value, onChange, onChangeSilent, usluga } = props;
    const data = (usluga && usluga.uslugiKlientuUslugaNaMeropriyatii) ? usluga.uslugiKlientuUslugaNaMeropriyatii : undefined;
    let genderID = value?.polzovatel?.genderID || value?.genderID;
    const setMergedObject = (obj) => {
        onChange({
            polzovatelStrokoi: obj.polzovatelStrokoi,
            polzovatelID: _.get(obj, "polzovatel.ID"),
            tovarVZakazeID: item.ID
        });
    };
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            prefix={(genderID == 1) ? <MaleHeader /> : (genderID == 2) ? <FemaleHeader /> : <Header icon="user-alt-3" title="" style={{ color: "cadetblue", fontSize: "13px" }} />}
            item={item}
            gender={genderID}
            index={index}
            data={data}
            value={value}
            onChangeSilent={onChangeSilent}
            onChange={(e) => setMergedObject(e)} />
    </div>);
};
const RenderCartItem = (props) => {
    const classes = useStyles();
    const { auth, item, index, onInsideChange, deleteItem, zakaz, uslugi } = props;
    const usluga = uslugi.find(e => e.Usluga?.ID === item?.uslugaNaMeropriyatii?.ID)?.Usluga;
    const description = (<div>
        {(!!item.uslugaNaMeropriyatii && !!item.uslugaNaMeropriyatii.opisanie) && <div style={{ fontSize: "13px" }}>
            <pre style={{
                margin: "0",
                padding: "0",
                whiteSpace: "pre-wrap",
                fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans- serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
            }}>
                {item.uslugaNaMeropriyatii.opisanie}
            </pre>
        </div>}
    </div>);
    const newPolzovateliVZakazeTovarVZakaze = (zakaz, polzovateliVZakazeTovarVZakaze) => {
        return {
            ...zakaz, tovariVZakazeZakaz: zakaz.tovariVZakazeZakaz.map(e => {
                if (e.ID === item.ID) {
                    return {
                        ...e,
                        polzovateliVZakazeTovarVZakaze: polzovateliVZakazeTovarVZakaze(e)
                    }
                }
                return e;
            })
        }
    };
    const newTovarVZakaze = (zakaz, tovarVZakaze) => {
        return {
            ...zakaz, tovariVZakazeZakaz: zakaz.tovariVZakazeZakaz.map(e => {
                if (e.ID === tovarVZakaze.ID) {
                    return {
                        ...e,
                        ...tovarVZakaze
                    }
                }
                return e;
            })
        }
    };
    const onPolzovateliVZakazeTovarVZakaze = (p, old) => {
        POST(auth, "/api/zakaz/tovar/polzovatel/change", {
            delPolzovatel: old,
            newPolzovatel: p
        }, ({ data }) => {
            onInsideChange(newPolzovateliVZakazeTovarVZakaze(zakaz, (e) => {
                if (old) {
                    return [...((e.polzovateliVZakazeTovarVZakaze) ? e.polzovateliVZakazeTovarVZakaze.filter(f => f.ID !== old.ID) : []), data];
                } else {
                    return [...((e.polzovateliVZakazeTovarVZakaze) ? e.polzovateliVZakazeTovarVZakaze : []), data];
                }
            }), uslugi);
        }, errorCatch);
    };
    const onChangeSilent = (people) => {
        let z = newPolzovateliVZakazeTovarVZakaze(zakaz, (e) =>
            [...((e.polzovateliVZakazeTovarVZakaze) ? e.polzovateliVZakazeTovarVZakaze.map(p => {
                if (p.ID === people.ID) {
                    return people;
                }
                return p;
            }) : [])]
        );
        onInsideChange(z, uslugi);
    };
    const onChangeTovar = (tovar) => {
        let z = newTovarVZakaze(zakaz, tovar);
        onInsideChange(z, uslugi);
    };
    const getPeopleByGender = (array, genderID) => {
        if (!array) return;


        for (let i = 0; i < array.length; i++) {
            const element = array[i];
            if ((element.polzovatel && element.polzovatel.genderID === genderID) ||
                (element.genderID && element.genderID === genderID) ||
                (element.polzovatelStrokoi)) {
                return element;
            }
        }
        // if (array.length > defaultIndex) {
        //     return array[defaultIndex];
        // }
    };

    // console.log(item);

    // item?.uslugaNaMeropriyatii?.vklyuchitKommentarii == true

    // console.log(item?.kommentarii);

    // /api/zakaz/tovar/kommentarii/add
    // post
    // принимает товар в заказе с комментарием

    return (<>
        <div style={{ flex: "auto" }}>
            <List.Item.Meta
                className={classes.listMeta}
                title={item.uslugaNaMeropriyatii.nazvanie}
                description={description}
            />
            <div style={{ alignSelf: "flex-start", textAlign: "start" }}>
                <div style={{ padding: "5px 0px" }}>
                    {(item.uslugaNaMeropriyatii.vidUslugiID === 1) &&
                        <Male auth={auth} item={item} index={index}
                            value={getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 1)}
                            onChangeSilent={onChangeSilent}
                            onChange={(v) => onPolzovateliVZakazeTovarVZakaze(v, getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 1, 0))}
                            usluga={usluga} />
                    }
                    {(item.uslugaNaMeropriyatii.vidUslugiID === 2) &&
                        <Female auth={auth} item={item} index={index}
                            value={getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 2)}
                            onChangeSilent={onChangeSilent}
                            onChange={(v) => onPolzovateliVZakazeTovarVZakaze(v, getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 2, 0))}
                            usluga={usluga} />
                    }
                    {(item.uslugaNaMeropriyatii.vidUslugiID === 3) &&
                        <div style={{ display: "flex", justifyContent: "flex-start" }}>
                            <div>
                                <div style={{ paddingBottom: "5px" }}>
                                    <SingleByGender auth={auth} usluga={usluga} item={item} index={index}
                                        value={_.get(item, "polzovateliVZakazeTovarVZakaze[0]")}
                                        onChangeSilent={onChangeSilent}
                                        onChange={(v) => onPolzovateliVZakazeTovarVZakaze(v, _.get(item, "polzovateliVZakazeTovarVZakaze[0]"))} />
                                </div>
                                <div style={{ paddingBottom: "5px" }}>
                                    <SingleByGender auth={auth} usluga={usluga} item={item} index={index}
                                        value={_.get(item, "polzovateliVZakazeTovarVZakaze[1]")}
                                        onChangeSilent={onChangeSilent}
                                        onChange={(v) => onPolzovateliVZakazeTovarVZakaze(v, _.get(item, "polzovateliVZakazeTovarVZakaze[1]"))} />
                                </div>
                            </div>
                        </div>}
                    {(item.uslugaNaMeropriyatii.vidUslugiID === 4) &&
                        <Single auth={auth} item={item} index={index}
                            value={_.get(item, "polzovateliVZakazeTovarVZakaze[0]")}
                            onChangeSilent={onChangeSilent}
                            onChange={(v) => onPolzovateliVZakazeTovarVZakaze(v, _.get(item, "polzovateliVZakazeTovarVZakaze[0]"))}
                            usluga={usluga} />
                    }
                </div>
            </div>
            {(item?.uslugaNaMeropriyatii?.vklyuchitKommentarii == true) && <div style={{ maxWidth: "500px" }}>
                <Action
                    auth={auth}
                    okText="Сохранить"
                    action={(values, unlock, close) => {
                        POST(auth, `/api/zakaz/tovar/kommentarii/add`, {
                            ...item,
                            ...values
                        }, ({ data }) => {
                            onChangeTovar({ ...item, kommentarii: data?.kommentarii })
                            close()
                        }, (err) => errorCatch(err, () => unlock()))
                    }}
                    object={item}
                    form={Model}
                    meta={[
                        {
                            label: "Комментарий покупателя",
                            name: "kommentarii",
                            type: "text",
                            size: "small"
                        }
                    ]}
                    mode={"func"}
                    trigger={(click) => (
                        <div className='bg bg-transparent pointer border-grey' style={{ fontSize: "12px", textAlign: "left", margin: "5px 0" }}
                            onClick={click}>
                            <div style={{ fontSize: "11px", color: "rgba(0,0,0,.65)", display: "flex", justifyContent: "space-between" }}>
                                <div><i className="fa fa-comments-o"></i> Комментарий покупателя</div>
                                <div><i className="fa fa-pencil-square-o"></i></div>
                            </div>
                            {/* <div>{item?.kommentarii}</div> */}
                            <div><Nl2Br text={item?.kommentarii} /></div>
                        </div>
                    )}
                />
            </div>}
        </div>
        <div>
            <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "16px" }}>
                <div style={(item.tsena !== item.tsenaDoPromokoda) ? { textDecoration: "line-through" } : {}}>{(item.tsenaDoPromokoda).toLocaleString()} руб.</div>
                {(item.tsena !== item.tsenaDoPromokoda) && <div style={{ color: "red" }}>{(item.tsena).toLocaleString()} руб.</div>}
                <div style={{ textAlign: "end" }}>
                    <div style={{ display: "flex", justifyContent: "end" }}>
                        <Button type="text" style={{ fontWeight: "600", padding: "4px 8px", fontSize: "12px" }}
                            onClick={deleteItem}>
                            <Icofont icon="ui-delete" />
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    </>)
};
const RenderSelectItem = (props) => {
    const classes = useStyles();
    const { item } = props;
    const tarif = item.Tarifi[0];
    const description = (<div>
        {item.Usluga.opisanie && <div style={{ fontSize: "13px" }}>
            <pre style={{
                margin: "0",
                padding: "0",
                whiteSpace: "pre-wrap",
                fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans- serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
            }}>
                {item.Usluga.opisanie}
            </pre>
        </div>}
    </div >);
    return (<>
        <div style={{ flex: "auto" }}>
            <List.Item.Meta className={classes.listMeta}
                title={item.Usluga.nazvanie}
                description={description}
            />
            <div style={{ alignSelf: "flex-start", textAlign: "start" }}>
                <div style={{ padding: "5px 0px" }}>
                    {(item.Usluga.vidUslugiID === 1) && <MaleHeader />}
                    {(item.Usluga.vidUslugiID === 2) && <FemaleHeader />}
                    {(item.Usluga.vidUslugiID === 3) && <CoupleHeader />}
                    {(item.Usluga.vidUslugiID === 4) && <SingleHeader />}
                </div>
            </div>
        </div>
        <div>
            <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "16px" }}>
                <div style={(tarif.PricePromo !== tarif.PriceTarif) ? { textDecoration: "line-through" } : {}}>{(tarif.PriceTarif).toLocaleString()} руб.</div>
                {(tarif.PricePromo !== tarif.PriceTarif) && <div style={{ color: "red" }}>{(tarif.PricePromo).toLocaleString()} руб.</div>}
            </div>
        </div>
    </>)
};
const SelectUslugiForm = (props) => {
    const classes = useStyles();
    const { auth, form, object, submit, promo, data } = props;
    useEffect(() => {
        form.setFieldsValue({ collection: object });
    }, [object]);
    return (<div>
        {promo && <div style={{ fontWeight: "400" }}>
            <span>ПРОМОКОД: </span>
            <span style={{ fontWeight: "600", color: "red" }}>{promo}</span>
        </div>}
        <Form
            form={form}
            onFinish={submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={{ collection: object }}
        >
            <Form.Item name="collection" className={classes.itemsListUsluga}>
                <Collection
                    //data={_.pullAllBy([...data], object, 'ID') || []}
                    getSelectedOnly={true}
                    data={data || []}
                    selection="checkbox"
                    auth={auth}
                    noPrint={true}
                    noPagination={true}
                    size="small"
                    mode="list"
                    listRenderItem={(item, index) => <RenderSelectItem uuid={uuid()} item={item} index={index} />}
                    collectionActions={() => []}
                    modelActions={() => []}
                />
            </Form.Item>
        </Form>
    </div>)
};
function InputGroup({ value, onChange, options, onKeyPress, className }) {
    return (
        <Input.Group className={className} compact style={{ display: "flex" }}>
            <Input
                allowClear
                bordered={false}
                onChange={onChange}
                onKeyPress={onKeyPress}
                value={value}
            />
            {options}
        </Input.Group>
    );
}
function Dimmy({ constant, value, onChange }) {
    useEffect(() => {
        onChange(constant || value);
    }, [constant, value]);
    return <></>;
}
function SelectUserForm(props) {
    const dispatch = useDispatch();
    const { auth, form, data, object, gender, user } = props;
    const [isString, setIsString] = useState(false);
    const [radioValue, setRadioValue] = useState(-1);

    // founded
    const founded = useSelector(state => state.home.founded);

    const zaregistrirovanniiPolzovatel = data.some(e => (e.yacheikaUsluga.zaregistrirovanniiPolzovatel === true || e.yacheikaUsluga.prilozhenieID > 0));
    const minifyPeople = (people) => {
        return {
            ID: people.ID,
            firstname: people.firstname,
            lastname: people.lastname,
            genderID: (people.gender) ? people.gender.ID : undefined
        }
    };
    const setObjectPeoole = (people) => {
        form.setFieldsValue({
            polzovatel: minifyPeople(people)
        });
    };
    useEffect(() => {
        if (object) {
            if (!object.polzovatel && object.polzovatelStrokoi) {
                setIsString(true);
                setRadioValue(0);
            } else if (object.polzovatel) {
                setIsString(false);
                if (user.ID === object.polzovatelID) {
                    setRadioValue(-1);
                    setObjectPeoole(user);
                } if (object.polzovatelID > 0 && !!founded.find(e => e.ID == object.polzovatelID)) {
                    var u = founded.find(e => e.ID == object.polzovatelID);
                    setRadioValue(object.polzovatelID);
                    setObjectPeoole(u);
                } else {
                    setRadioValue(0);
                    setObjectPeoole(object.polzovatel);
                }

            }
        }
    }, [object]);
    const objectPeopleSelection = (value) => {
        setRadioValue(+value);
        if (value === -1) {
            setObjectPeoole(user);
        }
        if (value > 0) {
            setObjectPeoole(founded.find(e => e.ID == value));
        }
    };
    const findObjectPeople = (value) => {
        if (value === -1) {
            return user;
        }
        if (value > 0) {
            return founded.find(e => e.ID == value);
        }
    };
    // const setFoundedPeople = (value) => {
    //     let f = _.unionBy([value], founded || [], 'ID').filter(e => e.ID !== user.ID)
    //     dispatch({ type: 'FOUNDED', payload: f });
    //     return minifyPeople(value);
    // };
    return (<div>
        <div style={{ paddingBottom: "10px" }}>
            <Radio.Group onChange={(e) => objectPeopleSelection(+e.target.value)} value={radioValue}>
                <Space direction="vertical">
                    <Radio value={-1}>Я участник ({user.firstname + " " + user.lastname})</Radio>
                    {founded && founded.map(e => (
                        <Radio key={e.ID} value={e.ID}>{e.firstname + " " + e.lastname}</Radio>
                    ))}
                    <Radio value={0}>Другой человек</Radio>
                </Space>
            </Radio.Group>
            {(radioValue === 0 && zaregistrirovanniiPolzovatel !== true) && <div style={{ paddingTop: "10px" }}>
                <Checkbox checked={isString} onChange={(e) => setIsString(e.target.checked)}>Указать участника строкой</Checkbox>
            </div>}
        </div>
        <div>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={object}
            >
                {(radioValue > 0) && <>
                    <Form.Item label="" name="polzovatel">
                        <Dimmy constant={findObjectPeople(radioValue)} />
                    </Form.Item>
                </>}
                {(radioValue === -1) && <>
                    <Form.Item label="" name="polzovatel">
                        <Dimmy constant={minifyPeople(user)} />
                    </Form.Item>
                </>}
                {(radioValue === 0) && <>
                    {(isString && radioValue === 0) &&
                        <Form.Item label="ФИО"
                            name="polzovatelStrokoi"
                            rules={[{ required: false, message: 'Пожалуйста, укажите ФИО!' }]}
                        >
                            <Input />
                        </Form.Item>
                    }
                    {!isString && <>
                        <Form.Item label="" name="otherPolzovatel">
                            <InputWithSearchModal
                                valueAsObject={true}
                                // modifyValue={setFoundedPeople}
                                auth={auth}
                                title={"Поиск пользователя"}
                                url={"/api/find/finduserfilter"}
                                object={{ Gender: gender }}
                                searchForm={UserFilter}
                                selectForm={UserSelector} />
                        </Form.Item>
                    </>}
                </>}
            </Form>
        </div>
    </div>);
}
function SelectPartnerForm(props) {
    const dispatch = useDispatch();
    const { auth, form, data, object, gender, user } = props;
    // const [isString, setIsString] = useState(false);
    const [radioValue, setRadioValue] = useState(-1);

    // founded
    const founded = useSelector(state => state.home.founded);

    const zaregistrirovanniiPolzovatel = data.some(e => (e.yacheikaUsluga.zaregistrirovanniiPolzovatel === true || e.yacheikaUsluga.prilozhenieID > 0));
    const minifyPeople = (people) => {
        return {
            ID: people.ID,
            firstname: people.firstname,
            lastname: people.lastname,
            genderID: (people.gender) ? people.gender.ID : undefined
        }
    };
    const setObjectPeoole = (people) => {
        form.setFieldsValue({
            polzovatel: minifyPeople(people)
        });
    };
    useEffect(() => {
        if (object) {
            if (object.polzovatel) {

                if (user.ID === object.polzovatelID) {
                    setRadioValue(-1);
                    setObjectPeoole(user);
                } if (object.polzovatelID > 0 && !!founded.find(e => e.ID == object.polzovatelID)) {
                    var u = founded.find(e => e.ID == object.polzovatelID);
                    setRadioValue(object.polzovatelID);
                    setObjectPeoole(u);
                } else {
                    setRadioValue(0);
                    setObjectPeoole(object.polzovatel);
                }

            }
        }
    }, [object]);
    const objectPeopleSelection = (value) => {
        setRadioValue(+value);
        if (value === -1) {
            setObjectPeoole(user);
        }
        if (value > 0) {
            setObjectPeoole(founded.find(e => e.ID == value));
        }
    };
    const findObjectPeople = (value) => {
        if (value === -1) {
            return user;
        }
        if (value > 0) {
            return founded.find(e => e.ID == value);
        }
    };
    // const setFoundedPeople = (value) => {
    //     let f = _.unionBy([value], founded || [], 'ID').filter(e => e.ID !== user.ID)
    //     dispatch({ type: 'FOUNDED', payload: f });
    //     return minifyPeople(value);
    // };
    return (<div>
        <div style={{ paddingBottom: "10px" }}>
            <Radio.Group onChange={(e) => objectPeopleSelection(+e.target.value)} value={radioValue}>
                <Space direction="vertical">
                    <Radio value={-1}>Я участник ({user.firstname + " " + user.lastname})</Radio>
                    {founded && founded.map(e => (
                        <Radio key={e.ID} value={e.ID}>{e.firstname + " " + e.lastname}</Radio>
                    ))}
                    <Radio value={0}>Другой человек</Radio>
                </Space>
            </Radio.Group>
        </div>
        <div>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={object}
            >
                {(radioValue > 0) && <>
                    <Form.Item label="" name="polzovatel">
                        <Dimmy constant={findObjectPeople(radioValue)} />
                    </Form.Item>
                </>}
                {(radioValue === -1) && <>
                    <Form.Item label="" name="polzovatel">
                        <Dimmy constant={minifyPeople(user)} />
                    </Form.Item>
                </>}
                {(radioValue === 0) && <>
                    <Form.Item label="" name="otherPolzovatel">
                        <InputWithSearchModal
                            valueAsObject={true}
                            // modifyValue={setFoundedPeople}
                            auth={auth}
                            title={"Поиск пользователя"}
                            url={"/api/find/finduserfilter"}
                            object={{ Gender: gender }}
                            searchForm={UserFilter}
                            selectForm={UserSelector} />
                    </Form.Item>
                </>}
            </Form>
        </div>
    </div>);
}
function CollectionList(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { auth, value, onInsideChange, zakaz, uslugi, promo } = props;
    const user = useSelector(state => state.home.user);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        auth.fetch('/api/iam').then(res => {
            if (res && res.data) {
                dispatch({ type: 'USER', payload: res.data })
            }
        });

    }, []);

    const founded = useSelector(state => state.home.founded);
    useEffect(() => {
        let userList = [];
        if (zakaz && zakaz.tovariVZakazeZakaz && zakaz.tovariVZakazeZakaz.length) {
            for (let i = 0; i < zakaz.tovariVZakazeZakaz.length; i++) {
                let tovar = zakaz.tovariVZakazeZakaz[i];
                if (tovar && tovar.polzovateliVZakazeTovarVZakaze && tovar.polzovateliVZakazeTovarVZakaze.length) {
                    for (let j = 0; j < tovar.polzovateliVZakazeTovarVZakaze.length; j++) {
                        let user = tovar.polzovateliVZakazeTovarVZakaze[j];

                        if (user && user.polzovatel) {
                            userList.push(user.polzovatel);
                        }
                        if (user && user?.okazannieUslugiPolzovatelyamUchastik?.length) {
                            for (let k = 0; k < user?.okazannieUslugiPolzovatelyamUchastik.length; k++) {
                                if (user?.okazannieUslugiPolzovatelyamUchastik[k].partner) {
                                    userList.push(user?.okazannieUslugiPolzovatelyamUchastik[k].partner);
                                }
                            }
                        }
                    }
                }
            }
        }
        let f = _.unionBy(userList, founded || [], 'ID').filter(e => e.ID !== user.ID)
        dispatch({ type: 'FOUNDED', payload: f });
    }, [zakaz]);

    const deleteItem = (item) => {
        setLoading(true);
        POST(auth, `/api/zakaz/tovar/delete?promo=${promo}`, item,
            (res) => {
                onInsideChange(res.data /*zakaz*/, res.uslugiPrice);
                setLoading(false);
            }, (err) => errorCatch(err, () => setLoading(false)));
    };
    const addItem = (values, unlock, close) => {
        setLoading(true);
        let add = values?.collection?.filter(e => !!e && e.Usluga).map(e => e.Usluga);
        if (add && add.length) {

            POST(auth, `/api/zakaz/tovar/add?promo=${promo}`, add,
                (res) => {
                    onInsideChange(res.data /*zakaz*/, res.uslugiPrice);
                    setLoading(false);
                    close();
                }, (err) => errorCatch(err, () => setLoading(false)));
        } else {
            setLoading(false);
            close();
        }
    };

    const addRandomUslugi = useCallback(({ key }) => {
        // e.preventDefault();

        setLoading(true);
        GET(auth, `/api/zakaz/dev-generate-uslugi/${zakaz?.ID}/${key}`,
            (res) => {
                window.location.href = window.location.href;
            }, (err) => errorCatch(err, () => setLoading(false)));
    }, [auth, setLoading, zakaz])

    const itemsRandomUslugi = React.useMemo(() => ([
        {
            label: 'Любые услуги',
            key: '0',
            disabled: loading,
        },
        {
            label: 'Jack',
            key: '1',
            disabled: loading,
        },
        {
            label: 'Jam',
            key: '2',
            disabled: loading,
        },
        {
            label: 'Party',
            key: '3',
            disabled: loading,
        },
    ]), [loading]);
    return (
        <div>
            <div style={{ padding: "15px 0px" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Action
                        modal={{ title: "Выбор услуг", width: "600px" }}
                        auth={auth}
                        data={uslugi}
                        object={value}
                        promo={promo}
                        title={"ДОБАВИТЬ УСЛУГИ"}
                        triggerOptions={{ className: classes.appendButton }}
                        triggerStyle={{ textAlign: "center" }}
                        okText="Выбрать"
                        form={SelectUslugiForm}
                        action={addItem}
                    />
                    {(auth.appProfile != "prod") && <div style={{ display: "flex", gap: "5px" }}>
                        <Dropdown menu={{ items: itemsRandomUslugi, onClick: addRandomUslugi }}>
                            <Button loading={loading} >
                                <Space>
                                    Автоматически добавить услуги
                                    <DownOutlined />
                                </Space>
                            </Button>
                        </Dropdown>

                        <Button danger loading={loading} onClick={(e) => {
                            e.preventDefault();

                            setLoading(true);
                            GET(auth, `/api/zakaz/clear/${zakaz?.ID}`,
                                (res) => {
                                    onInsideChange(res.data /*zakaz*/, res.uslugiPrice);
                                    setLoading(false);
                                }, (err) => errorCatch(err, () => setLoading(false)));
                        }}>
                            Очистить заказ
                        </Button>
                    </div>}
                </div>
            </div>
            {(user && (user.firstname || user.lastname)) &&
                <List
                    className={classes.itemsOrderUsluga}
                    locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Не выбраны услуги" /> }}
                    style={{ borderBottom: "1px solid #f0f0f0", borderTop: "1px solid #f0f0f0" }}
                    itemLayout="horizontal"
                    dataSource={value}
                    loading={loading}
                    renderItem={(item, index) => (
                        <List.Item>
                            <RenderCartItem auth={auth} uuid={uuid()} item={item} index={index} zakaz={zakaz} uslugi={uslugi} promo={promo}
                                deleteItem={() => deleteItem(item)}
                                onInsideChange={(zakaz, uslugi) => {
                                    onInsideChange(zakaz, uslugi);
                                }} />
                        </List.Item>
                    )}
                />}
            <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "500", fontSize: "16px", padding: "10px 0px" }}>
                <div>
                    ИТОГО:
                </div>
                <div>
                    {_.sumBy(value, (e) => e.tsena).toLocaleString()} руб.
                </div>
            </div>
        </div>
    );
}
export function DatiVozvratov(props) {
    const { event } = props;
    const auth = useAuth()
    const [data, setData] = useState(undefined);
    const [object, setObject] = useState(undefined);

    useEffect(() => {
        if (event) {
            GET(auth, `/papi/fed/meropriyatiya/get/${event}`,
                ({ data }) => {
                    if (data && data.length) {
                        setObject(data[0]);
                    }
                }, errorCatch);
            GET(auth, `/papi/fed/dativozvratov/bymeropriyatie/${event}`,
                ({ data }) => {
                    if (data && data.length) {
                        setData(data);
                    }
                }, errorCatch);
        }
    }, [event]);

    const declOfNum = (number, words) => {
        return words[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? Math.abs(number) % 10 : 5]];
    }
    const nl2br = (str, is_xhtml) => {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        let s = (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        return s.replace(/(http[^\s|^\<]*)/g, "<a href='$1' target='_blank' rel='noopener noreferrer' >$1</a>")
    }
    const url2a = (str) => {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        return str.replace(/(http[^\s|^\<]*)/g, "<a href='$1' target='_blank' rel='noopener noreferrer' >$1</a>")
    }
    return (<>
        <div>
            {(object && object.shapkaUsloviiVozvrata) && <div style={{ paddingBottom: "10px" }}>
                <pre style={{
                    margin: "0",
                    padding: "0",
                    whiteSpace: "pre-wrap",
                    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans- serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
                }}>
                    {parse(url2a(object.shapkaUsloviiVozvrata))}
                </pre>
            </div>}
            {(data && data.length > 0) && <div style={{ paddingBottom: "10px" }}>
                <div>Взимается сервисный сбор, который составляет:</div>
                {JSXMap(data, (e, eidx) => (
                    <div key={eidx} style={{ paddingBottom: "5px" }}>
                        <div style={{ fontWeight: "500" }}> - при возврате до {dayjs(e.dataVremya).format("DD.MM.YYYY (HH:mm)")} - {100 - e.protsent}%{(eidx != (data.length - 1)) ? "," : ""}</div>
                    </div>
                ))}
            </div>}
            {(object && object.podvalUsloviiVozvrata) && <div style={{ paddingBottom: "10px" }}>
                <pre style={{
                    margin: "0",
                    padding: "0",
                    whiteSpace: "pre-wrap",
                    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans- serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
                }}>
                    {parse(url2a(object.podvalUsloviiVozvrata))}
                </pre>
            </div>}
        </div>
    </>)
}
export default function PaymentForm(props) {
    const classes = useStyles();
    const { auth, form, steps, idx } = props;
    const [zakaz, setZakaz] = useState({});
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        form.resetFields();
        request();
    }, []);
    const [uslugi, setUslugi] = useState([]);
    const [promo, setPromo] = useState(""); //Вечеринка21
    const request = () => {
        setLoading(true);
        GET(auth, `/api/usluginameropriyatii/nowbymeropriyatieidandpromo/${steps[idx].event.ID}?promo=${promo}`,
            (res) => {
                setZakaz(res.zakaz);
                form.resetFields();
                form.setFieldsValue(res.zakaz);
                setUslugi(res.data || []);
                setPromo(res.zakaz.promokod);
                setLoading(false);
            }, (err) => errorCatch(err, () => setLoading(false)));
    };
    const updateFromInside = (zakaz, uslugi) => {
        setZakaz(zakaz);
        form.resetFields();
        form.setFieldsValue(zakaz);
        setUslugi(uslugi);
    };
    const validator = (func, message) => ({
        validator: (_, value) => {
            if (func(value)) {
                return Promise.resolve();
            }
            return Promise.reject(new Error(message))
        }
    });
    const isSetUser = (value) => {
        if (!value) return false;
        for (let i = 0; i < value.length; i++) {
            const item = value[i];
            if (!item.polzovateliVZakazeTovarVZakaze || item.polzovateliVZakazeTovarVZakaze.length <= 0) {
                return false;
            }
            if (item.uslugaNaMeropriyatii.vidUslugiID == 3 && item.polzovateliVZakazeTovarVZakaze.length < 2) {
                return false;
            }
            for (let id = 0; id < item.polzovateliVZakazeTovarVZakaze.length; id++) {
                const people = item.polzovateliVZakazeTovarVZakaze[id];
                if (!people) {
                    return false;
                }
                if (!people.polzovatelStrokoi && !people.polzovatel) {
                    return false;
                }
            }
        }
        return true;
    };
    const isSetCategory = (value) => {
        if (!value) return false;
        for (let i = 0; i < value.length; i++) {
            const item = value[i];
            if (item.polzovateliVZakazeTovarVZakaze) {
                for (let id = 0; id < item.polzovateliVZakazeTovarVZakaze.length; id++) {
                    const people = item.polzovateliVZakazeTovarVZakaze[id];
                    if (people) {
                        for (let k = 0; k < people.okazannieUslugiPolzovatelyamUchastik.length; k++) {
                            const y = people.okazannieUslugiPolzovatelyamUchastik[k];
                            if (y.uslugaKlientu.yacheikaUsluga.prilozhenieID) {
                                if (!y.kategoriya) {
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
        }
        return true;
    };
    const isSetPartners = (value) => {
        if (!value) return false;
        for (let i = 0; i < value.length; i++) {
            const item = value[i];
            if (item.polzovateliVZakazeTovarVZakaze) {
                for (let id = 0; id < item.polzovateliVZakazeTovarVZakaze.length; id++) {
                    const people = item.polzovateliVZakazeTovarVZakaze[id];
                    if (people) {
                        for (let k = 0; k < people.okazannieUslugiPolzovatelyamUchastik.length; k++) {
                            const y = people.okazannieUslugiPolzovatelyamUchastik[k];
                            if (y.uslugaKlientu.yacheikaUsluga.prilozhenieID) {
                                if ((y.tipTDID === 1 || y.tipTDID === 2) && !y.partner) {
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
        }
        return true;
    };
    const keyPress = (e) => {
        if (e.key === 'Enter') {
            request();
        }
    };
    return (
        <>
            <Spin spinning={loading}>
                <Form
                    form={form}
                    onFinish={props.submit}
                    labelAlign={"left"}
                    layout={"vertical"}
                    onValuesChange={(changedValues, allValues) => {
                        setPromo(allValues.promokod);
                    }}
                >
                    <Form.Item
                        label=""
                        name="tovariVZakazeZakaz"
                        rules={[
                            { type: "array", required: true, message: 'Пожалуйста, выберите услуги!' },
                            validator(isSetUser, 'Пожалуйста, укажите участников!'),
                            validator(isSetCategory, 'Пожалуйста, укажите категории!'),
                            validator(isSetPartners, 'Пожалуйста, укажите партнеров!'),
                        ]}
                    >
                        <CollectionList zakaz={zakaz} auth={auth} uslugi={uslugi} promo={zakaz.promokod} onInsideChange={updateFromInside} />
                    </Form.Item>
                    <div style={{ display: "flex", justifyContent: "end" }}>
                        <Form.Item label="Промокод"
                            name="promokod"
                            rules={[{ required: false, message: 'Пожалуйста, укажите промокод!' }]}
                            style={{ width: "30%", marginBottom: "30px" }}
                        >
                            <InputGroup
                                className={classes.promo}
                                onKeyPress={keyPress}
                                options={[
                                    <Button id="9c7cbdff-c48f-4afb-8abe-92779d7b870d" className="apply" key="1" type="text" style={{ fontWeight: "600", padding: "4px 8px" }} onClick={request}>
                                        ПРИМЕНИТЬ
                                    </Button>
                                ]}
                            />
                        </Form.Item>
                    </div>
                    <div style={{
                        fontSize: "12px",
                        paddingLeft: "20px"
                    }}>
                        <DatiVozvratov event={zakaz?.meropriyatieID} />
                    </div>
                    <Form.Item
                        name="agreement"
                        valuePropName="checked"
                        rules={[validator((value) => !!value, 'Пожалуйста, подтвердите согласие с правилами!')]}
                    >
                        <Checkbox>
                            <Typography style={{ fontSize: "12px" }}>
                                {(!!zakaz?.nastroikaEkvairingaID) && <Agreement nastroikaEkvairingaID={zakaz?.nastroikaEkvairingaID}/>}
                            </Typography>
                        </Checkbox>
                    </Form.Item>
                </Form>
            </Spin>
        </>
    );
}
// PaymentForm.whyDidYouRender = true
// CollectionList.whyDidYouRender = true
